// Viperia free delivery game (snippets/vp-delivery-game.liquid). A leopard gecko eats one cricket for every fifth
// of the free delivery threshold and reaches its basking lamp at the end. Basket totals arrive ex VAT, so they are
// shown x1.2 like the rest of the site. Live animals and custom builds don't count and carry their own fee; items
// over the pallet weight go by pallet. Updates whenever the basket changes, from any add-to-basket on the page.
(function () {
  'use strict';
  var el = document.getElementById('VpDeliveryGame');
  if (!el) return;
  var d = el.dataset;
  var threshold = Number(d.threshold) || 7900;
  // Trade customers see their threshold ex VAT, as trade terms are quoted: free delivery over £500 + VAT
  var trade = d.trade === '1';
  function over() { return trade ? fmt(Math.round(threshold / 1.2)) + ' + VAT' : fmt(threshold); }
  var vat = Number(d.vat) || 1.2;
  var fee = Number(d.fee) || 5000;
  var palletGrams = Number(d.palletGrams) || 30000;
  var list = function (s) { return (s || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean); };
  var animalTypes = list(d.animalTypes), customTypes = list(d.customTypes), skipTypes = list(d.skipTypes);
  var money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var $ = function (s) { return el.querySelector(s); };
  var crickets = el.querySelectorAll('.vp-fdg__cricket');
  var N = crickets.length || 5;
  var gecko = $('[data-gecko]');
  var suggest = $('[data-suggest]'), sImg = $('[data-s-img]'), sText = $('[data-s-text]'), sAdd = $('[data-s-add]');
  var KEY = 'vp-fdg-min';
  var MAX_GAP = 3500; // £35 inc VAT
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var phone = window.matchMedia('(max-width: 749px)');
  var last = null, pick = null, busy = false, inCart = [], lastProduct = null, cache = {};

  var TOTAL = 'vp-fdg-total', shrinkTimer = null;
  function savedTotal() { try { var v = sessionStorage.getItem(TOTAL); return v === null ? null : Number(v); } catch (e) { return null; } }
  function saveTotal(v) { try { sessionStorage.setItem(TOTAL, String(v)); } catch (e) {} }
  function store(v) { try { if (v == null) sessionStorage.removeItem(KEY); else sessionStorage.setItem(KEY, v); } catch (e) {} }
  function read() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function fmt(pence) { return money.format(Math.max(0, pence) / 100).replace(/\.00$/, ''); }
  function typeOf(t) { return (t || '').toLowerCase(); }
  function inc(exPence) { return Math.round(exPence * vat); }

  // Where the gecko stands: just behind the first cricket, at the last one eaten, or under the lamp.
  function geckoX(eaten, done) {
    if (done) return 195;
    if (!eaten) return -52;
    return 44 + (eaten - 1) * 46 - 80;
  }

  // ---------- Walking and eating ----------
  var shown = null, runId = 0;
  var MOUTH_X = 83, MOUTH_Y = 53;           // gecko mouth tip, in scene units, relative to the gecko's x
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function moveGecko(x, secs) { gecko.style.transitionDuration = secs + 's'; gecko.style.transform = 'translateX(' + x + 'px)'; }
  function bodyOf(cr) { return cr.querySelector('.vp-fdg__cricket-body'); }
  function resetCricket(cr) { var b = bodyOf(cr); cr.classList.remove('is-eaten'); b.style.transition = ''; b.style.transform = ''; b.style.opacity = ''; }
  function hideCricket(cr) { cr.classList.add('is-eaten'); }
  function eat(i, id) {
    var cr = crickets[i], cx = Number(cr.dataset.cx), sx = Number(cr.dataset.sx) || 1;
    var at = cx - MOUTH_X;                  // gecko x with its mouth on the cricket
    el.classList.add('is-walking');
    moveGecko(at - 16, .75);
    return wait(760).then(function () {
      if (id !== runId) return;
      el.classList.remove('is-walking');
      el.classList.add('is-open');
      return wait(170);
    }).then(function () {
      if (id !== runId) return;
      moveGecko(at, .22);                   // quick lunge
      var b = bodyOf(cr), s = Math.abs(sx);
      var dx = (cx + 2 - cx) / sx, dy = (MOUTH_Y - 59) / s;
      b.style.transition = 'transform .26s ease-in, opacity .26s ease-in';
      b.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.2)';
      b.style.opacity = '0';
      return wait(280);
    }).then(function () {
      if (id !== runId) return;
      hideCricket(cr);
      el.classList.remove('is-open');
      el.classList.add('is-chew');
      return wait(480);
    }).then(function () { el.classList.remove('is-chew'); });
  }
  // A small burst of confetti over the card when free delivery is unlocked. Pieces remove themselves.
  var confettiDue = false;
  function confetti() {
    confettiDue = false;
    if (reduce) return;
    var card = $('.vp-fdg__card'); if (!card) return;
    var box = document.createElement('div'); box.className = 'vp-fdg__confetti'; box.setAttribute('aria-hidden', 'true');
    var colours = ['#00807a', '#99cc34', '#122220', '#f2b233', '#7fd3cd'];
    for (var i = 0; i < 36; i++) {
      var p = document.createElement('i');
      var a = (Math.random() * 140 + 200) * Math.PI / 180;   // mostly upwards, fanning out
      var d = 70 + Math.random() * 90;
      p.style.setProperty('--x', Math.round(Math.cos(a) * d * 1.6) + 'px');
      p.style.setProperty('--y', Math.round(Math.sin(a) * d) + 'px');
      p.style.setProperty('--r', Math.round(Math.random() * 720 - 360) + 'deg');
      p.style.left = (35 + Math.random() * 30) + '%';
      p.style.background = colours[i % colours.length];
      p.style.animationDelay = Math.round(Math.random() * 120) + 'ms';
      if (i % 3 === 0) p.style.borderRadius = '50%';
      box.appendChild(p);
    }
    card.appendChild(box);
    setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 1900);
  }
  function run(eaten, done) {
    var id = ++runId;
    if (reduce || shown === null) {         // first paint, or reduced motion: no walking
      crickets.forEach(function (cr, i) { if (i < eaten) hideCricket(cr); else resetCricket(cr); });
      moveGecko(geckoX(eaten, done), 0);
      el.classList.toggle('is-done', done);
      if (done && confettiDue) confetti();
      shown = eaten;
      return;
    }
    if (eaten < shown) {                    // something was removed: put the crickets back
      crickets.forEach(function (cr, i) { if (i >= eaten) resetCricket(cr); });
      moveGecko(geckoX(eaten, false), .5);
      shown = eaten;
    }
    var chain = Promise.resolve();
    for (var i = shown; i < eaten; i++) {
      (function (n) { chain = chain.then(function () { if (id === runId) return eat(n, id).then(function () { if (id === runId) shown = n + 1; }); }); })(i);
    }
    chain.then(function () {
      if (id !== runId) return;
      if (done) {
        el.classList.add('is-walking');
        moveGecko(geckoX(eaten, true), .9);
        return wait(920).then(function () { if (id !== runId) return; el.classList.remove('is-walking'); el.classList.add('is-done'); if (confettiDue) confetti(); });
      }
      moveGecko(geckoX(eaten, false), .3);
    });
  }

  function setMin(min) {
    el.classList.toggle('is-min', min);
    $('[data-expand]').setAttribute('aria-expanded', String(!min));
  }

  // Trade prices: BSS B2B keeps the retail price in the basket and only swaps the trade price in on screen, so
  // for trade customers each line is priced from BSS's own price lists (fixed trade price per variant, ex VAT).
  function tradeLine(it) {
    var rules = trade && window.BSS_B2B && window.BSS_B2B.pl && window.BSS_B2B.pl.plRules;
    if (!rules || !it.variant_id) return it.final_line_price;
    for (var i = 0; i < rules.length; i++) {
      var vs = rules[i].selected_variants || [];
      for (var j = 0; j < vs.length; j++) {
        if (String(vs[j].variant_id) === String(it.variant_id) && Number(vs[j].discount_type) === 0) {
          return Math.round(parseFloat(vs[j].discount_value) * 100) * it.quantity;
        }
      }
    }
    return it.final_line_price;
  }
  window.vpTradeLinePrice = function (it) { return tradeLine(it); };

  function read_cart(items) {
    var eligibleEx = 0, animal = false, custom = false, pallet = false, count = 0, productId = null, ownVivs = 0;
    items.forEach(function (it) {
      var t = typeOf(it.product_type);
      count += it.quantity;
      if (skipTypes.indexOf(t) > -1) return;
      // Trade rule is simple (Liam, 4 Nov): everything over £500 + VAT is free, livestock and custom builds included
      if (!trade && animalTypes.indexOf(t) > -1) { animal = true; return; }
      if (!trade && customTypes.indexOf(t) > -1) { custom = true; return; }
      if (it.quantity && (it.grams / it.quantity) > palletGrams) pallet = true;
      // our own vivariums: two or more in a basket and pallet delivery is free
      if (t === 'vivariums' && String(it.vendor || '').toLowerCase().indexOf('viperia') === 0) ownVivs += it.quantity;
      eligibleEx += tradeLine(it);
      productId = it.product_id;
    });
    return { total: inc(eligibleEx), animal: animal, custom: custom, pallet: pallet, palletFree: pallet && ownVivs >= 2, count: count, productId: productId };
  }

  function show(c) {
    var left = Math.max(0, threshold - c.total);
    var done = c.total >= threshold;
    var pct = Math.min(1, c.total / threshold);
    var eaten = done ? N : Math.min(N - 1, Math.floor(pct * N));
    var toGo = N - eaten;
    var state = c.total === 0 ? 'empty' : done ? 'done' : toGo <= 1 ? 'near' : 'progress';
    var head, sub, pill;
    if (state === 'empty') {
      head = (trade ? 'Free trade delivery over ' : 'Free delivery over ') + over();
      sub = 'Every ' + (trade ? fmt(Math.round(threshold / 1.2 / N)) + ' + VAT' : fmt(threshold / N)) + ' you add feeds the gecko a cricket. Five crickets and delivery is free.';
      pill = (trade ? 'Free trade delivery over ' : 'Free delivery over ') + over();
    } else if (state === 'done') {
      head = 'Free delivery unlocked';
      sub = 'The gecko’s basking under its lamp. Delivery is free on this order.';
      pill = 'Free delivery unlocked';
    } else {
      // trade amounts are + VAT, like their prices
      var gap = trade ? fmt(Math.round(left / 1.2)) + ' + VAT' : fmt(left);
      head = state === 'near' ? 'Nearly there: ' + gap + ' to go' : gap + ' more for free delivery';
      sub = toGo + (toGo === 1 ? ' cricket' : ' crickets') + ' left. Delivery is free over ' + over() + '.';
      pill = gap + ' to free delivery';
    }
    // Our shipping rules for retail: a pallet vivarium is charged at checkout unless the basket has two or more of
    // our vivariums, then delivery is free. Trade is free over £500 + VAT even by pallet, so trade keeps the normal bar.
    var palletDue = c.pallet && !trade && !c.palletFree;
    if (c.pallet && !trade && c.palletFree) {
      done = true; state = 'done'; eaten = N;
      head = 'Free delivery unlocked';
      sub = 'Two Viperia vivariums in your basket, so pallet delivery is free on this order.';
      pill = 'Free delivery unlocked';
    }
    if (palletDue) {
      done = false; state = 'pallet'; eaten = 0;
      head = 'Pallet delivery on this order';
      sub = 'Your vivarium is too big for a courier, so it goes by pallet. You’ll see the pallet price at checkout. Add a second Viperia vivarium and delivery is free.';
      pill = 'Pallet delivery: priced at checkout';
    }
    $('[data-msg]').textContent = head;
    $('[data-sub]').textContent = sub;
    $('[data-pill-text]').textContent = pill;
    $('[data-pill-fill]').style.width = (palletDue ? 0 : Math.round((done ? 1 : pct) * 100)) + '%';

    var notes = [];
    if (c.animal && c.custom) notes.push('Live animals and custom vivariums have their own ' + fmt(fee) + ' delivery charge and don’t count towards free delivery.');
    else if (c.animal) notes.push('Live animal delivery is ' + fmt(fee) + ' and doesn’t count towards free delivery.');
    else if (c.custom) notes.push('Custom vivarium delivery is ' + fmt(fee) + ' and doesn’t count towards free delivery.');
    var note = $('[data-note]');
    note.textContent = notes.join(' ');
    note.hidden = !notes.length;

    // The gecko walks up to each new cricket, opens its mouth and eats it; the next cricket hops.
    crickets.forEach(function (cr, i) { cr.classList.toggle('is-next', i === eaten && state !== 'empty' && state !== 'pallet' && !done); });
    if (!done) el.classList.remove('is-done');
    var before = last ? last.total : savedTotal();
    if (done && before !== null && before < threshold) confettiDue = true;
    run(eaten, done);

    el.dataset.state = state;
    // Something was added (on this page, or before the page reloaded): always open the card so the shopper
    // sees the gecko move, even if they shrank it earlier. On phones it shrinks again after a few seconds.
    if (before !== null && c.total > before) {
      if (done && before < threshold) { el.classList.remove('is-win'); void el.offsetWidth; el.classList.add('is-win'); }
      setMin(false);
      clearTimeout(shrinkTimer);
      if (phone.matches) shrinkTimer = setTimeout(function () { setMin(true); }, 5000);
    }
    saveTotal(c.total);
    last = { eaten: eaten, done: done, total: c.total };
    el.hidden = false;
    suggestFor(state === 'done' || state === 'empty' || state === 'pallet' ? 0 : left, c.productId);
  }

  function priceOf(v) {
    // Product JSON gives pence as a number (recommendations) or pounds as a string (collections); both ex VAT.
    var p = typeof v.price === 'string' && v.price.indexOf('.') > -1 ? Math.round(parseFloat(v.price) * 100) : Number(v.price);
    return inc(p);
  }
  function imgOf(p) {
    var src = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0]));
    if (!src || typeof src !== 'string') return null;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  }
  function getJSON(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { cache[url] = j.products || []; return cache[url]; })
      .catch(function () { return []; });
  }

  // Recently viewed products, kept in this browser only and only when the shopper has allowed preference
  // cookies on the consent banner. Newest first, at most 12 handles.
  var VIEWED = 'vp-viewed';
  function preferencesAllowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return !!(cp && typeof cp.preferencesProcessingAllowed === 'function' && cp.preferencesProcessingAllowed());
  }
  function viewedList() {
    if (!preferencesAllowed()) return [];
    try { return JSON.parse(localStorage.getItem(VIEWED) || '[]').filter(function (h) { return typeof h === 'string'; }); } catch (e) { return []; }
  }
  function rememberView() {
    if (!d.viewing || !preferencesAllowed()) return;
    try {
      var list = viewedList().filter(function (h) { return h !== d.viewing; });
      list.unshift(d.viewing);
      localStorage.setItem(VIEWED, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }
  function viewedProducts() {
    var root = (d.root || '/').replace(/\/?$/, '/');
    var handles = viewedList().filter(function (h) { return h !== d.viewing; });
    if (!handles.length) return Promise.resolve([]);
    return Promise.all(handles.map(function (h) {
      var url = root + 'products/' + encodeURIComponent(h) + '.js';
      if (cache[url]) return Promise.resolve(cache[url]);
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { cache[url] = p; return p; })
        .catch(function () { return null; });
    })).then(function (list) { return list.filter(Boolean); });
  }
  function loadConsentApi(done) {
    if (window.Shopify && window.Shopify.customerPrivacy) return done();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { done(); });
    } else done();
  }

  // Suggest the cheapest product that closes the gap on its own: first something the shopper has looked at,
  // then items related to what's in the basket, then the chosen collection. Never live animals, custom builds
  // or things already in the basket.
  function suggestFor(left, productId) {
    // Only when the gap is small enough for one add-on, and never an item that overshoots it by much.
    if (!left || left > MAX_GAP) { suggest.hidden = true; return; }
    // Trade customers only buy our own vivariums and livestock, so no retail add-ons for them
    if (trade) { suggest.hidden = true; return; }
    var overshoot = Math.max(1500, Math.round(left / 2));
    var root = (d.root || '/').replace(/\/?$/, '/');
    var sources = [viewedProducts];
    if (productId) sources.push(root + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=related');
    if (d.collection) sources.push(root + 'collections/' + d.collection + '/products.json?limit=250');
    var tryNext = function (i) {
      if (i >= sources.length) { suggest.hidden = true; return; }
      (typeof sources[i] === 'function' ? sources[i]() : getJSON(sources[i])).then(function (products) {
        var best = null;
        products.forEach(function (p) {
          var t = typeOf(p.product_type || p.type);
          if (animalTypes.indexOf(t) > -1 || customTypes.indexOf(t) > -1 || skipTypes.indexOf(t) > -1) return;
          if (inCart.indexOf(p.id) > -1) return;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return;
          var price = priceOf(v);
          if (price >= left && price <= left + overshoot && (!best || price < best.price)) best = { id: v.id, price: price, title: p.title, img: imgOf(p) };
        });
        if (!best) return tryNext(i + 1);
        pick = best;
        sText.textContent = (i === 0 ? 'You looked at ' + best.title + '. Add it and delivery is free.' : 'Add ' + best.title + ' and delivery is free.');
        sAdd.textContent = 'Add ' + fmt(best.price);
        if (best.img) { sImg.src = best.img; sImg.hidden = false; } else sImg.hidden = true;
        suggest.hidden = false;
      });
    };
    tryNext(0);
  }

  sAdd.addEventListener('click', function () {
    if (!pick || busy) return;
    busy = true; sAdd.disabled = true;
    fetch((d.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: pick.id, quantity: 1, properties: { _vp_source: 'delivery-game' } }], sections: 'cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && res.sections && res.sections['cart-icon-bubble']) {
        var tmp = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (tmp) bubble.innerHTML = tmp.innerHTML;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vp-fdg' });
    }).catch(function () {}).then(function () { busy = false; sAdd.disabled = false; refresh(); });
  });

  var timer = null;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      nativeFetch((d.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          inCart = (cart.items || []).map(function (i) { return i.product_id; });
          show(read_cart(cart.items || []));
        })
        .catch(function () {});
    }, 250);
  }

  // Any add, change or clear on the page (theme forms, the setup builder, Loop, apps) refreshes the game.
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(refresh, function () {});
    return p;
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(); });
  // BSS's price lists arrive after this script, so trade baskets are re-priced once they're there
  if (trade) { window.addEventListener('load', refresh); setTimeout(refresh, 2500); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  $('[data-collapse]').addEventListener('click', function () { setMin(true); store('1'); });
  $('[data-expand]').addEventListener('click', function () { var min = !el.classList.contains('is-min'); setMin(min); store(min ? '1' : null); });

  var start = { items: [] };
  try { start = JSON.parse($('[data-cart]').textContent); } catch (e) {}
  inCart = start.items.map(function (i) { return i.product_id; });
  var first = read_cart(start.items);
  // Start shrunk on phones, on an empty basket, and wherever the shopper shrank it earlier in this visit.
  setMin(read() === '1' || phone.matches || first.total === 0);
  var started = false;
  var go = function () { if (started) return; started = true; rememberView(); show(first); };
  // In theme preview Shopify puts its preview bar along the bottom of the screen; sit above it.
  var lift = function () { var bar = document.getElementById('preview-bar-iframe') || document.getElementById('PBarNextFrameWrapper'); if (bar && bar.offsetHeight) el.style.bottom = (bar.offsetHeight + 16) + 'px'; };
  [500, 1500, 3000, 6000].forEach(function (t) { setTimeout(lift, t); });
  loadConsentApi(go);
  setTimeout(go, 1500); // never wait on the consent script to show the card
  document.addEventListener('visitorConsentCollected', rememberView);
})();
